import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Container, Card } from "react-bootstrap";
import styles from '../../styles/Firstconnexion.module.scss';
import SetupPassword from "../setuppassword";
import axios from "axios";
import { GeneralContext } from "../../contexts/GeneralContext";
import Cookies from 'js-cookie';
import ModalPortal from "../portal/modal";
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

const FirstConnexion = () =>{
    /*
        Si Secret present = Paiement
        Si Token présent = connexion ancien patient Emno
    */
    let { id, email, secret, token } = useParams();
    const navigate = useNavigate();
    const generalDetails = useContext(GeneralContext);

    const [userRole, setUserRole] = useState();
    // State for the expired link modal
    const [linkExpired, setLinkExpired] = useState({
        show: false,
        isLoading: false,
        isSent: false,
        isError: false,
    });

    useEffect(() => {
        if (Cookies.get('NuveeSession')) Cookies.remove('NuveeSession');
    }, [])

    useEffect(() => {
        if (!userRole && id && email && token) {
            axios.post(process.env.REACT_APP_NUVEE_BASE_URL + '/users-permissions/checkUser', {id, email, token})
            .then(response => {
                    const { redirectTo, role, expired_link } = response.data;
                    if (redirectTo) {
                        window.location.href = redirectTo;
                    } else {
                        setUserRole(role);
                        setLinkExpired(p => ({...p, show: !!expired_link}));
                    }
                })
                .catch((error) => {
                    console.error(error);
                    generalDetails.setAlert({
                        show: true,
                        message: "Il y a un problème de communication avec notre serveur. Veuillez réessayer plus tard",
                        header: "Erreur serveur",
                        dismissible: true,
                        variant: "danger",
                        timout: 5000,
                    });
                });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, email, token]);

    const handlePasswordChanged = (password) => {
        navigate('/login', { state: { email: email, password: password, submit: true, redirectAfterLoginFirstConnexion: true, secret: secret, id: id } });
    }

    const handleResendLink = () => {
        setLinkExpired(p => ({...p, isLoading: true}));
        axios.post(process.env.REACT_APP_NUVEE_BASE_URL + '/auth/forgot-password', { email })
            .then(({ status } )=> {
                if (status !== 204) throw new Error("Erreur lors de l'envoi du lien");
                setLinkExpired(p => ({...p, isLoading: false, isSent: true}));
            })
            .catch((error) => {
                console.error(error);
                setLinkExpired(p => ({...p, isLoading: false, isError: true}));
            });
    }

    // Simple function to get the button text for the resend link button
    const getExpiredLinkButton = () => {
        if (linkExpired.isError) return "Une erreur est survenue, merci de réessayer plus tard";
        if (linkExpired.isSent) return "Le lien a été envoyé";
        if (linkExpired.isLoading) return <FontAwesomeIcon icon={faSpinner} spin />;
        else return "Recevoir mon lien par email";
    }

    return (
        <Container>
            <Card bsPrefix=" " className={`mt-5 ${styles.card}`}>
                <Card.Header className={`${styles.cardHeader}`} as="h1">
                    Inscription à Nuvee
                </Card.Header>
                <h1 className={styles.etape}>
                    &Eacute;tape 1 : Définition du mot de passe
                </h1>
                <Card.Body className={`${styles.cardBody}`}>
                    <SetupPassword id={id} email={email} token={token} afterPasswordChanged={handlePasswordChanged} userRole={userRole} />
                </Card.Body>
            </Card>
            {/* Modal for expired link */}
            <ModalPortal
                // Force the modal to stay open, to avoid user closing and trying to set his password.
                handleClose={() => {}}
                title={""}
                show={linkExpired.show}
                footerModal={
                    <Button 
                        variant={"primary"}
                        disabled={linkExpired.isLoading || linkExpired.isSent}
                        onClick={handleResendLink}
                    >
                        {getExpiredLinkButton()}
                    </Button>
                }
            >
                <p>
                    Pour des raisons de s&eacute;curit&eacute;, le lien que vous avez re&ccedil;u a expir&eacute;. 
                </p>
                <p>
                    Veuillez cliquer sur le bouton ci-dessous pour recevoir un nouveau lien pour activer votre compte.
                </p>
            </ModalPortal>
        </Container>
    );
}

export default FirstConnexion;